import { styled } from 'styled-components';
import CategoryIcon from '../../gel/iconography/icons';

export const StyledValidIcon = styled(CategoryIcon).attrs((props) => ({
    ...props,
    name: 'confirm',
}))`
    fill: currentcolor;
`;
